<div class="multiselect-block" [ngClass]="{'all-users': selectedUsers?.length === users?.length}">
	<div class="multiselect-label" style="font-size: 90%; color: #b1b1b1;">
		Managers Filter
	</div>

	<p-multiSelect #multiSelect [defaultLabel]="'Project Managers'" [selectedItemsLabel]="'{0} users selected'" [options]="users"
		styleClass="payment-multiselect" [optionLabel]="'username'" [(ngModel)]="selectedUsers" [showToggleAll]="true"
		(onChange)="updateManagers()" [filter]="false" [maxSelectedLabels]="1">
		<p-header (click)="showAll()">
			Show All
		</p-header>
	</p-multiSelect>
</div>